// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-panel .card-title {
    color: #ffffff !important;
    background: #005b88 !important;
}

.components-panel .drag-over-new-empty-col img {
    background: #a58e5f !important;
}



::ng-deep .builder-components .card {
    background-color: #005b88;
    background-clip: border-box;
    border: 0px;
    border-bottom: 1px solid #ebedf2;
    border-radius: 0;
}

.card-title:after {
    color: #fff !important;
}

.accordion.accordion-toggle-arrow .card {
    background: #005b88;
    padding: 0 10px;
}

.accordion.accordion-toggle-arrow .card .card-header .card-title.collapsed {
    color: #fff !important;
}

.accordion.accordion-toggle-arrow .card .card-header .card-title {
    color: #fff !important;
    font-weight: 500;
}

.accordion.accordion-toggle-arrow .card .card-header .card-title.collapsed:after {
    color: #fff;
}

.accordion.accordion-toggle-arrow .card .card-header .card-title:after {
    color: #fff !important;
}

.card-body {
    background: transparent;
    color: #fff;
    border: 0;
}

.comp-scroll {
    overflow: auto;
    height: 87vh;
}

.builder-scroll {
    overflow: auto;
    height: 100vh;
}

.comp-scroll::-webkit-scrollbar {
    width: 10px;
}


/* Track */

.comp-scroll::-webkit-scrollbar-track {
    border-radius: 15px;
}


/* Handle */

.comp-scroll::-webkit-scrollbar-thumb {
    background: #008fc7;
    border-radius: 15px;
}


/* Handle on hover */

.comp-scroll::-webkit-scrollbar-thumb:hover {
    background: #1396ca;
}

.components-panel {
    background: #005b88;
    right: 0;
    overflow: hidden;
}

.components-panel>input {
    background: #005b88;
    border-radius: 0;
    color: #fff;
}

.searchText {
    padding-top: 5px;
    color: #fff !important;
}

.subheader-span-btn-padding {
    padding: 0.5rem 0 !important;
}

.panel-body.card-block.card-body .dragged-component {
    background: #e5f7ff;
    border: 1px solid #bdbdbd;
    padding: 1.5em;
    margin: 3px;
    border-style: dashed;
    border-radius: 5px;
    height: 100%;
}

.dragged-component:hover {
    background: #d7f3ff;
    border: 1px solid #008fc7;
}

.builder-actions {
    /* margin: 22px 0 3px 0; */
    padding: 0;
    margin: 5px 0 3px 0;
    padding: 0;
}

.page-container {
    border: 1px solid #00a1ff;
    border-style: dashed;
    border-radius: 5px;
    padding: 0;
    min-height: 78vh;
}

.left-side {
    margin-bottom: 0px;
    overflow: auto;
    position: absolute;
    bottom: 0px;
    padding-bottom: 15px;
    top: 56px;
}

.add-new-comp {
    background: #008fc7;
    border: 0px !important;
    padding: 0.5em !important;
}

.plus-icon {
    margin-left: 5px;
}

.comp-item {
    padding: 0.8em;
    list-style-type: none;
    margin: 0.5em;
    color: #fff;
    border-radius: 5px;
    border: 1px solid #d0d0d0;
}

.comp-images {
    display: block;
    margin: auto;
    width: 100%;
}

.comp-name {
    color: white;
    text-align: center;
}

.comp-item-draggable {
    border: 1px white;
    margin-bottom: 15px;
}

.navbar {
    border-bottom: 1px solid white !important;
}

.block-actions {
    display: none;
    position: absolute;
    left: 0;
    top: 0;
    background: #19b5fe;
    color: #fff;
    padding: 0px 5px;
    border-radius: 0 0px 5px 0px;
}

.block-actions .fas {
    margin: 0 10px;
}

.dragged-component:hover .block-actions {
    display: block;
}

.drop-zone {
    animation-delay: 0s;
    animation-duration: 0.5s;
    background: #d9eaf2;
    border-radius: 5px;
}

.layout-button {
    background: #008fc7;
    padding: 4px;
    border-radius: 5px;
    cursor: pointer;
    z-index: 10;
    height: 32px;
    margin-bottom: 2px;
    cursor: pointer;
}

.layout-button.active {
    background: #008fc7;
}

.dimentions-controllers {
    position: absolute;
    width: 90%;
}

.inline-blk {
    display: inline-block;
}

.layout-btn {
    display: inline-block;
}

.edit-layout-btn {
    display: inline-block;
    background-color: rgba(0, 143, 199, 0.1);
    height: 33px;
    line-height: 0px;
    z-index: 9;
    padding: 5px 0;
    border-radius: 5px 0 0 5px;
}

.edit-layout-btn i {
    margin: 0 10px;
}

.view-selectors-btn {
    text-align: center;
}

.view-selectors-btn>span {
    cursor: pointer;
}

.fas.fa-arrow-left.fa-lg.btn {
    color: #008fc7 !important;
    cursor: pointer;
}

.preview-builder {
    border: transparent;
    background-color: rgba(0, 143, 199, 0.1);
    padding: 8px 20px;
    color: #008fc7;
}

.preview-builder.active {
    background-color: #008fc7;
    color: #f2f2f2;
}

.preview-builder.active:hover {
    background-color: rgba(0, 143, 199, 0.1);
    color: #008fc7;
}

.brl-5 {
    border-radius: 5px 0 0 5px;
}

.brr-5 {
    border-radius: 0 5px 5px 0;
}

.layout-btn {
    margin-right: 20px;
    border-right: 1px solid #ccc;
    padding-right: 20px;
}

.edit-layout-btn i {
    font-size: 21px;
}

.iframe-preview {
    height: 100vh;
    border: transparent;
    border-radius: 5px;
}

.from-template {
    background: #ffecb3;
}

.from-template .dragged-component {
    background: #ffecb3;
}

.sizing-block {
    display: block;
    position: absolute;
    bottom: 0;
    top: initial;
    left: initial;
    border-radius: 5px 5px 0px 0px;
    z-index: 10;
    cursor: pointer;
}

.sizing-pop .col input {
    display: inline-block;
    width: 35px;
}

.btn.btn-link:hover {
    background: transparent !important;
}

.searchText {
    color: #fff !important;
}

.alias-text {
    border: 0;
    border-radius: 5px;
}

.alias-text:active {
    border: 0;
}

.alias-text:focus {
    border: 0;
}

.text-center.add-blocks.action-block.inner {
    right: 15px;
}

.has-component {
    background: #e4f3f8 !important;
}

.has-component .text-center {
    background: #e4f3f8 !important;
}

.col-style.col-style-temp .row {
    margin-right: 15px;
    margin-left: 15px;
}

.inner-height {
    padding: 20px;
}

.row-style.text-center.row {
    padding: 0 25px;
}


/* page culture settings */

.page-cultrure-container {
    width: 100%;
    margin-bottom: 30px;
    display: flex;
}

.page-cultrure-container .box {
    width: 100%;
    padding: 20px 10px;
    background-color: #fff;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    border: solid 1px #dfe7ec;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 3px 2px;
}

.page-cultrure-container .box>div {
    align-items: center;
}

.page-cultrure-container .box>div>div {
    padding: 0px 5px;
}

ul.culture-ul {
    margin: 0px;
    padding: 0px;
}
ul li.culture-list{
    list-style-type: none;
    border-bottom: dashed 1px #e4e8ee;
}
.comp-scroll {
    /* Adjust height or overflow as needed */
    overflow-y: auto; 
    max-height: 300px; 
  }
  
  .mat-expansion-panel-header.card-title {
    background-color: #f5f5f5; /* Example background color */
    padding: 10px 16px; /* Example padding */
    font-weight: bold;
  }
  
  .comp-item-draggable {
    /* Add spacing or borders as needed */
    margin-bottom: 10px;
  }
  .mat-expansion-panel {
    padding: 0 !important; /* Remove default padding */
  }
  
  .mat-expansion-panel-header {
    margin: 0 !important; /* Remove default margin */
    padding: 10px 16px !important; /* Add padding to the header */
  }
  
  .comp-item-draggable {
    margin-bottom: 10px; /* Add spacing between draggable items */
  }
  
  .mat-expansion-panel-content {
    padding: 10px !important; /* Add padding to the content area */
  }
  .comp-item-draggable {
    cursor: move; /* Indicate draggability */
    transition: transform 0.2s ease; /* Smooth transition for drag animation */
    margin-bottom: 8px; /* Add spacing between items */
  }
  
  .comp-item-draggable:hover {
    transform: scale(1.05); /* Slightly scale up on hover */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Add a subtle shadow on hover */
  }
  
  .drag-over-new-empty-col {
    opacity: 0.7; /* Make the dragged element slightly transparent */
  }
  
  /* Optional: Add a dropzone highlight */
  .main-container.cdk-drop-list-dragging {
    border: 2px dashed #007bff; /* Highlight the dropzone */
  }
  .comp-scroll { /* Add this to target the accordion specifically */
    overflow: hidden; /* Hide the default scrollbar */
  }

  .comp-item-draggable {
    cursor: move;
    transition: transform 0.2s ease;
    margin-bottom: 8px;
    border: 1px solid #ccc; /* Add a border to each draggable item */
    padding: 10px; /* Add some padding */
    border-radius: 5px; /* Add rounded corners */
  }

  .comp-item-draggable:hover {
    transform: scale(1.05);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .drag-over-new-empty-col {
    opacity: 0.7;
  }

  .mat-expansion-panel-content::-webkit-scrollbar { 
    width: 5px; /* Set the width of the scrollbar */
  }

  .mat-expansion-panel-content::-webkit-scrollbar-track {
    background: #f1f1f1; /* Set the background color of the scrollbar track */
  }

  .mat-expansion-panel-content::-webkit-scrollbar-thumb {
    background: #888; /* Set the color of the scrollbar thumb */
    border-radius: 10px; /* Add rounded corners to the scrollbar thumb */
  }

  .mat-expansion-panel-content::-webkit-scrollbar-thumb:hover {
    background: #555; /* Change the color of the thumb on hover */
  }
  .mat-expansion-panel-body {
    padding: 0 !important; /* Remove any default padding from the panel body */
  }
  .cdk-drag-preview { /* Apply styles to the drag preview */
    z-index: 1000 !important; 
  }
  .container {
    text-align: center;

    .inner-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        margin-top: 5%;

        .img {

            max-width: 300px;
            width: 300px; 
        }

        .title {
            font-size: 2rem;
            font-weight: bold;
            color: #000;
            margin-bottom: 1rem;
        }

        .description {
            font-size: 1rem;
            color: #000;
        }
    }
}
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-content {
    position: relative;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    padding: 24px;
    width: 90%;
    max-width: 800px;
    overflow: hidden;
    animation: fadeIn 0.3s ease;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  .close-button {
    position: absolute;
    top: 16px;
    right: 16px;
    background: none;
    border: none;
    font-size: 24px;
    color: #333;
    cursor: pointer;
  }

  .header {
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 16px;
    text-align: center;
    color: #1976d2;
  }

  .search-bar {
    width: 100%;
    margin-bottom: 24px;
  }

  .cards-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 16px;
  }

  .card {
    border: 1px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    background-color: #fff;
    cursor: pointer;
  }

  .card:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  }

  .card-image {
    width: 100%;
    height: 150px;
    object-fit: cover;
  }

  .card-content {
    padding: 16px;
    text-align: left;
  }

  .card-content h3 {
    font-size: 1.2rem;
    margin: 0 0 8px;
    color: #333;
  }

  .card-content p {
    margin: 0;
    font-size: 0.9rem;
    color: #666;
  }

  .pagination-controls {
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
  }

  .no-templates {
    text-align: center;
    padding: 24px;
  }

  .no-templates-image {
    width: 100%;
    max-width: 300px;
    margin-bottom: 16px;
  }

  .no-templates-title {
    font-size: 1.5rem;
    color: #555;
  }
  .modal-content {
    position: relative;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    padding: 24px;
    width: 90%;
    max-width: 800px;
    max-height: 90vh; /* Ensure the modal does not exceed 90% of the viewport height */
    overflow-y: auto; /* Enable scrolling for content overflow */
  }
  
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .cards-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 16px;
  }
  
  .pagination-controls {
    display: flex;
    justify-content: center;
    margin-top: 16px;
    gap: 16px;
  }
  
  .pagination-arrow {
    background-color: #1976d2;
    color: white;
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.2s ease;
    font-size: 16px;
  }
  
  .pagination-arrow i {
    font-size: 20px;
  }
  
  .pagination-arrow:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
  
  .pagination-arrow:hover:not(:disabled) {
    background-color: #145a9e;
  }
  
  
  .close-button {
    position: absolute;
    top: 16px;
    right: 16px;
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
  }`, "",{"version":3,"sources":["webpack://./src/app/views/view-builder/view-builder.component.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;;;AAIA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,WAAW;IACX,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;;AAGA,UAAU;;AAEV;IACI,mBAAmB;AACvB;;;AAGA,WAAW;;AAEX;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;;AAGA,oBAAoB;;AAEpB;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,UAAU;IACV,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,wCAAwC;IACxC,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;IACxC,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;;AAGA,0BAA0B;;AAE1B;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,qBAAqB;IACrB,iCAAiC;AACrC;AACA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB,EAAE,6BAA6B;IACxD,kBAAkB,EAAE,oBAAoB;IACxC,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;EACrB;EACA;IACE,qBAAqB,EAAE,2BAA2B;EACpD;;EAEA;IACE,oBAAoB,EAAE,0BAA0B;IAChD,6BAA6B,EAAE,8BAA8B;EAC/D;;EAEA;IACE,mBAAmB,EAAE,wCAAwC;EAC/D;;EAEA;IACE,wBAAwB,EAAE,oCAAoC;EAChE;EACA;IACE,YAAY,EAAE,0BAA0B;IACxC,+BAA+B,EAAE,yCAAyC;IAC1E,kBAAkB,EAAE,8BAA8B;EACpD;;EAEA;IACE,sBAAsB,EAAE,+BAA+B;IACvD,wCAAwC,EAAE,iCAAiC;EAC7E;;EAEA;IACE,YAAY,EAAE,kDAAkD;EAClE;;EAEA,uCAAuC;EACvC;IACE,0BAA0B,EAAE,2BAA2B;EACzD;EACA,eAAe,kDAAkD;IAC/D,gBAAgB,EAAE,+BAA+B;EACnD;;EAEA;IACE,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;IAClB,sBAAsB,EAAE,wCAAwC;IAChE,aAAa,EAAE,qBAAqB;IACpC,kBAAkB,EAAE,wBAAwB;EAC9C;;EAEA;IACE,sBAAsB;IACtB,wCAAwC;EAC1C;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU,EAAE,mCAAmC;EACjD;;EAEA;IACE,mBAAmB,EAAE,oDAAoD;EAC3E;;EAEA;IACE,gBAAgB,EAAE,yCAAyC;IAC3D,mBAAmB,EAAE,+CAA+C;EACtE;;EAEA;IACE,gBAAgB,EAAE,2CAA2C;EAC/D;EACA;IACE,qBAAqB,EAAE,mDAAmD;EAC5E;EACA,oBAAoB,qCAAqC;IACvD,wBAAwB;EAC1B;EACA;IACE,kBAAkB;;IAElB;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;;QAEnB,cAAc;;QAEd;;YAEI,gBAAgB;YAChB,YAAY;QAChB;;QAEA;YACI,eAAe;YACf,iBAAiB;YACjB,WAAW;YACX,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,WAAW;QACf;IACJ;AACJ;AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yCAAyC;IACzC,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE;MACE,UAAU;MACV,qBAAqB;IACvB;IACA;MACE,UAAU;MACV,mBAAmB;IACrB;EACF;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;IACxC,qDAAqD;IACrD,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,yCAAyC;EAC3C;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,SAAS;IACT,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yCAAyC;IACzC,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,gBAAgB,EAAE,gEAAgE;IAClF,gBAAgB,EAAE,0CAA0C;EAC9D;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,sCAAsC;IACtC,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;;EAGA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;EACjB","sourcesContent":[".components-panel .card-title {\r\n    color: #ffffff !important;\r\n    background: #005b88 !important;\r\n}\r\n\r\n.components-panel .drag-over-new-empty-col img {\r\n    background: #a58e5f !important;\r\n}\r\n\r\n\r\n\r\n::ng-deep .builder-components .card {\r\n    background-color: #005b88;\r\n    background-clip: border-box;\r\n    border: 0px;\r\n    border-bottom: 1px solid #ebedf2;\r\n    border-radius: 0;\r\n}\r\n\r\n.card-title:after {\r\n    color: #fff !important;\r\n}\r\n\r\n.accordion.accordion-toggle-arrow .card {\r\n    background: #005b88;\r\n    padding: 0 10px;\r\n}\r\n\r\n.accordion.accordion-toggle-arrow .card .card-header .card-title.collapsed {\r\n    color: #fff !important;\r\n}\r\n\r\n.accordion.accordion-toggle-arrow .card .card-header .card-title {\r\n    color: #fff !important;\r\n    font-weight: 500;\r\n}\r\n\r\n.accordion.accordion-toggle-arrow .card .card-header .card-title.collapsed:after {\r\n    color: #fff;\r\n}\r\n\r\n.accordion.accordion-toggle-arrow .card .card-header .card-title:after {\r\n    color: #fff !important;\r\n}\r\n\r\n.card-body {\r\n    background: transparent;\r\n    color: #fff;\r\n    border: 0;\r\n}\r\n\r\n.comp-scroll {\r\n    overflow: auto;\r\n    height: 87vh;\r\n}\r\n\r\n.builder-scroll {\r\n    overflow: auto;\r\n    height: 100vh;\r\n}\r\n\r\n.comp-scroll::-webkit-scrollbar {\r\n    width: 10px;\r\n}\r\n\r\n\r\n/* Track */\r\n\r\n.comp-scroll::-webkit-scrollbar-track {\r\n    border-radius: 15px;\r\n}\r\n\r\n\r\n/* Handle */\r\n\r\n.comp-scroll::-webkit-scrollbar-thumb {\r\n    background: #008fc7;\r\n    border-radius: 15px;\r\n}\r\n\r\n\r\n/* Handle on hover */\r\n\r\n.comp-scroll::-webkit-scrollbar-thumb:hover {\r\n    background: #1396ca;\r\n}\r\n\r\n.components-panel {\r\n    background: #005b88;\r\n    right: 0;\r\n    overflow: hidden;\r\n}\r\n\r\n.components-panel>input {\r\n    background: #005b88;\r\n    border-radius: 0;\r\n    color: #fff;\r\n}\r\n\r\n.searchText {\r\n    padding-top: 5px;\r\n    color: #fff !important;\r\n}\r\n\r\n.subheader-span-btn-padding {\r\n    padding: 0.5rem 0 !important;\r\n}\r\n\r\n.panel-body.card-block.card-body .dragged-component {\r\n    background: #e5f7ff;\r\n    border: 1px solid #bdbdbd;\r\n    padding: 1.5em;\r\n    margin: 3px;\r\n    border-style: dashed;\r\n    border-radius: 5px;\r\n    height: 100%;\r\n}\r\n\r\n.dragged-component:hover {\r\n    background: #d7f3ff;\r\n    border: 1px solid #008fc7;\r\n}\r\n\r\n.builder-actions {\r\n    /* margin: 22px 0 3px 0; */\r\n    padding: 0;\r\n    margin: 5px 0 3px 0;\r\n    padding: 0;\r\n}\r\n\r\n.page-container {\r\n    border: 1px solid #00a1ff;\r\n    border-style: dashed;\r\n    border-radius: 5px;\r\n    padding: 0;\r\n    min-height: 78vh;\r\n}\r\n\r\n.left-side {\r\n    margin-bottom: 0px;\r\n    overflow: auto;\r\n    position: absolute;\r\n    bottom: 0px;\r\n    padding-bottom: 15px;\r\n    top: 56px;\r\n}\r\n\r\n.add-new-comp {\r\n    background: #008fc7;\r\n    border: 0px !important;\r\n    padding: 0.5em !important;\r\n}\r\n\r\n.plus-icon {\r\n    margin-left: 5px;\r\n}\r\n\r\n.comp-item {\r\n    padding: 0.8em;\r\n    list-style-type: none;\r\n    margin: 0.5em;\r\n    color: #fff;\r\n    border-radius: 5px;\r\n    border: 1px solid #d0d0d0;\r\n}\r\n\r\n.comp-images {\r\n    display: block;\r\n    margin: auto;\r\n    width: 100%;\r\n}\r\n\r\n.comp-name {\r\n    color: white;\r\n    text-align: center;\r\n}\r\n\r\n.comp-item-draggable {\r\n    border: 1px white;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.navbar {\r\n    border-bottom: 1px solid white !important;\r\n}\r\n\r\n.block-actions {\r\n    display: none;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    background: #19b5fe;\r\n    color: #fff;\r\n    padding: 0px 5px;\r\n    border-radius: 0 0px 5px 0px;\r\n}\r\n\r\n.block-actions .fas {\r\n    margin: 0 10px;\r\n}\r\n\r\n.dragged-component:hover .block-actions {\r\n    display: block;\r\n}\r\n\r\n.drop-zone {\r\n    animation-delay: 0s;\r\n    animation-duration: 0.5s;\r\n    background: #d9eaf2;\r\n    border-radius: 5px;\r\n}\r\n\r\n.layout-button {\r\n    background: #008fc7;\r\n    padding: 4px;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    z-index: 10;\r\n    height: 32px;\r\n    margin-bottom: 2px;\r\n    cursor: pointer;\r\n}\r\n\r\n.layout-button.active {\r\n    background: #008fc7;\r\n}\r\n\r\n.dimentions-controllers {\r\n    position: absolute;\r\n    width: 90%;\r\n}\r\n\r\n.inline-blk {\r\n    display: inline-block;\r\n}\r\n\r\n.layout-btn {\r\n    display: inline-block;\r\n}\r\n\r\n.edit-layout-btn {\r\n    display: inline-block;\r\n    background-color: rgba(0, 143, 199, 0.1);\r\n    height: 33px;\r\n    line-height: 0px;\r\n    z-index: 9;\r\n    padding: 5px 0;\r\n    border-radius: 5px 0 0 5px;\r\n}\r\n\r\n.edit-layout-btn i {\r\n    margin: 0 10px;\r\n}\r\n\r\n.view-selectors-btn {\r\n    text-align: center;\r\n}\r\n\r\n.view-selectors-btn>span {\r\n    cursor: pointer;\r\n}\r\n\r\n.fas.fa-arrow-left.fa-lg.btn {\r\n    color: #008fc7 !important;\r\n    cursor: pointer;\r\n}\r\n\r\n.preview-builder {\r\n    border: transparent;\r\n    background-color: rgba(0, 143, 199, 0.1);\r\n    padding: 8px 20px;\r\n    color: #008fc7;\r\n}\r\n\r\n.preview-builder.active {\r\n    background-color: #008fc7;\r\n    color: #f2f2f2;\r\n}\r\n\r\n.preview-builder.active:hover {\r\n    background-color: rgba(0, 143, 199, 0.1);\r\n    color: #008fc7;\r\n}\r\n\r\n.brl-5 {\r\n    border-radius: 5px 0 0 5px;\r\n}\r\n\r\n.brr-5 {\r\n    border-radius: 0 5px 5px 0;\r\n}\r\n\r\n.layout-btn {\r\n    margin-right: 20px;\r\n    border-right: 1px solid #ccc;\r\n    padding-right: 20px;\r\n}\r\n\r\n.edit-layout-btn i {\r\n    font-size: 21px;\r\n}\r\n\r\n.iframe-preview {\r\n    height: 100vh;\r\n    border: transparent;\r\n    border-radius: 5px;\r\n}\r\n\r\n.from-template {\r\n    background: #ffecb3;\r\n}\r\n\r\n.from-template .dragged-component {\r\n    background: #ffecb3;\r\n}\r\n\r\n.sizing-block {\r\n    display: block;\r\n    position: absolute;\r\n    bottom: 0;\r\n    top: initial;\r\n    left: initial;\r\n    border-radius: 5px 5px 0px 0px;\r\n    z-index: 10;\r\n    cursor: pointer;\r\n}\r\n\r\n.sizing-pop .col input {\r\n    display: inline-block;\r\n    width: 35px;\r\n}\r\n\r\n.btn.btn-link:hover {\r\n    background: transparent !important;\r\n}\r\n\r\n.searchText {\r\n    color: #fff !important;\r\n}\r\n\r\n.alias-text {\r\n    border: 0;\r\n    border-radius: 5px;\r\n}\r\n\r\n.alias-text:active {\r\n    border: 0;\r\n}\r\n\r\n.alias-text:focus {\r\n    border: 0;\r\n}\r\n\r\n.text-center.add-blocks.action-block.inner {\r\n    right: 15px;\r\n}\r\n\r\n.has-component {\r\n    background: #e4f3f8 !important;\r\n}\r\n\r\n.has-component .text-center {\r\n    background: #e4f3f8 !important;\r\n}\r\n\r\n.col-style.col-style-temp .row {\r\n    margin-right: 15px;\r\n    margin-left: 15px;\r\n}\r\n\r\n.inner-height {\r\n    padding: 20px;\r\n}\r\n\r\n.row-style.text-center.row {\r\n    padding: 0 25px;\r\n}\r\n\r\n\r\n/* page culture settings */\r\n\r\n.page-cultrure-container {\r\n    width: 100%;\r\n    margin-bottom: 30px;\r\n    display: flex;\r\n}\r\n\r\n.page-cultrure-container .box {\r\n    width: 100%;\r\n    padding: 20px 10px;\r\n    background-color: #fff;\r\n    border-radius: 8px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    border: solid 1px #dfe7ec;\r\n    box-shadow: rgba(0, 0, 0, 0.08) 0px 3px 2px;\r\n}\r\n\r\n.page-cultrure-container .box>div {\r\n    align-items: center;\r\n}\r\n\r\n.page-cultrure-container .box>div>div {\r\n    padding: 0px 5px;\r\n}\r\n\r\nul.culture-ul {\r\n    margin: 0px;\r\n    padding: 0px;\r\n}\r\nul li.culture-list{\r\n    list-style-type: none;\r\n    border-bottom: dashed 1px #e4e8ee;\r\n}\r\n.comp-scroll {\r\n    /* Adjust height or overflow as needed */\r\n    overflow-y: auto; \r\n    max-height: 300px; \r\n  }\r\n  \r\n  .mat-expansion-panel-header.card-title {\r\n    background-color: #f5f5f5; /* Example background color */\r\n    padding: 10px 16px; /* Example padding */\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .comp-item-draggable {\r\n    /* Add spacing or borders as needed */\r\n    margin-bottom: 10px;\r\n  }\r\n  .mat-expansion-panel {\r\n    padding: 0 !important; /* Remove default padding */\r\n  }\r\n  \r\n  .mat-expansion-panel-header {\r\n    margin: 0 !important; /* Remove default margin */\r\n    padding: 10px 16px !important; /* Add padding to the header */\r\n  }\r\n  \r\n  .comp-item-draggable {\r\n    margin-bottom: 10px; /* Add spacing between draggable items */\r\n  }\r\n  \r\n  .mat-expansion-panel-content {\r\n    padding: 10px !important; /* Add padding to the content area */\r\n  }\r\n  .comp-item-draggable {\r\n    cursor: move; /* Indicate draggability */\r\n    transition: transform 0.2s ease; /* Smooth transition for drag animation */\r\n    margin-bottom: 8px; /* Add spacing between items */\r\n  }\r\n  \r\n  .comp-item-draggable:hover {\r\n    transform: scale(1.05); /* Slightly scale up on hover */\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Add a subtle shadow on hover */\r\n  }\r\n  \r\n  .drag-over-new-empty-col {\r\n    opacity: 0.7; /* Make the dragged element slightly transparent */\r\n  }\r\n  \r\n  /* Optional: Add a dropzone highlight */\r\n  .main-container.cdk-drop-list-dragging {\r\n    border: 2px dashed #007bff; /* Highlight the dropzone */\r\n  }\r\n  .comp-scroll { /* Add this to target the accordion specifically */\r\n    overflow: hidden; /* Hide the default scrollbar */\r\n  }\r\n\r\n  .comp-item-draggable {\r\n    cursor: move;\r\n    transition: transform 0.2s ease;\r\n    margin-bottom: 8px;\r\n    border: 1px solid #ccc; /* Add a border to each draggable item */\r\n    padding: 10px; /* Add some padding */\r\n    border-radius: 5px; /* Add rounded corners */\r\n  }\r\n\r\n  .comp-item-draggable:hover {\r\n    transform: scale(1.05);\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  }\r\n\r\n  .drag-over-new-empty-col {\r\n    opacity: 0.7;\r\n  }\r\n\r\n  .mat-expansion-panel-content::-webkit-scrollbar { \r\n    width: 5px; /* Set the width of the scrollbar */\r\n  }\r\n\r\n  .mat-expansion-panel-content::-webkit-scrollbar-track {\r\n    background: #f1f1f1; /* Set the background color of the scrollbar track */\r\n  }\r\n\r\n  .mat-expansion-panel-content::-webkit-scrollbar-thumb {\r\n    background: #888; /* Set the color of the scrollbar thumb */\r\n    border-radius: 10px; /* Add rounded corners to the scrollbar thumb */\r\n  }\r\n\r\n  .mat-expansion-panel-content::-webkit-scrollbar-thumb:hover {\r\n    background: #555; /* Change the color of the thumb on hover */\r\n  }\r\n  .mat-expansion-panel-body {\r\n    padding: 0 !important; /* Remove any default padding from the panel body */\r\n  }\r\n  .cdk-drag-preview { /* Apply styles to the drag preview */\r\n    z-index: 1000 !important; \r\n  }\r\n  .container {\r\n    text-align: center;\r\n\r\n    .inner-content {\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        align-items: center;\r\n\r\n        margin-top: 5%;\r\n\r\n        .img {\r\n\r\n            max-width: 300px;\r\n            width: 300px; \r\n        }\r\n\r\n        .title {\r\n            font-size: 2rem;\r\n            font-weight: bold;\r\n            color: #000;\r\n            margin-bottom: 1rem;\r\n        }\r\n\r\n        .description {\r\n            font-size: 1rem;\r\n            color: #000;\r\n        }\r\n    }\r\n}\r\n.modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1000;\r\n  }\r\n\r\n  .modal-content {\r\n    position: relative;\r\n    background: #fff;\r\n    border-radius: 12px;\r\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\r\n    padding: 24px;\r\n    width: 90%;\r\n    max-width: 800px;\r\n    overflow: hidden;\r\n    animation: fadeIn 0.3s ease;\r\n  }\r\n\r\n  @keyframes fadeIn {\r\n    from {\r\n      opacity: 0;\r\n      transform: scale(0.9);\r\n    }\r\n    to {\r\n      opacity: 1;\r\n      transform: scale(1);\r\n    }\r\n  }\r\n\r\n  .close-button {\r\n    position: absolute;\r\n    top: 16px;\r\n    right: 16px;\r\n    background: none;\r\n    border: none;\r\n    font-size: 24px;\r\n    color: #333;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .header {\r\n    font-size: 1.5rem;\r\n    font-weight: bold;\r\n    margin-bottom: 16px;\r\n    text-align: center;\r\n    color: #1976d2;\r\n  }\r\n\r\n  .search-bar {\r\n    width: 100%;\r\n    margin-bottom: 24px;\r\n  }\r\n\r\n  .cards-container {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n    gap: 16px;\r\n  }\r\n\r\n  .card {\r\n    border: 1px solid #ddd;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n    background-color: #fff;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .card:hover {\r\n    transform: translateY(-4px);\r\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\r\n  }\r\n\r\n  .card-image {\r\n    width: 100%;\r\n    height: 150px;\r\n    object-fit: cover;\r\n  }\r\n\r\n  .card-content {\r\n    padding: 16px;\r\n    text-align: left;\r\n  }\r\n\r\n  .card-content h3 {\r\n    font-size: 1.2rem;\r\n    margin: 0 0 8px;\r\n    color: #333;\r\n  }\r\n\r\n  .card-content p {\r\n    margin: 0;\r\n    font-size: 0.9rem;\r\n    color: #666;\r\n  }\r\n\r\n  .pagination-controls {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-top: 24px;\r\n  }\r\n\r\n  .no-templates {\r\n    text-align: center;\r\n    padding: 24px;\r\n  }\r\n\r\n  .no-templates-image {\r\n    width: 100%;\r\n    max-width: 300px;\r\n    margin-bottom: 16px;\r\n  }\r\n\r\n  .no-templates-title {\r\n    font-size: 1.5rem;\r\n    color: #555;\r\n  }\r\n  .modal-content {\r\n    position: relative;\r\n    background: #fff;\r\n    border-radius: 12px;\r\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\r\n    padding: 24px;\r\n    width: 90%;\r\n    max-width: 800px;\r\n    max-height: 90vh; /* Ensure the modal does not exceed 90% of the viewport height */\r\n    overflow-y: auto; /* Enable scrolling for content overflow */\r\n  }\r\n  \r\n  .modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .cards-container {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n    gap: 16px;\r\n  }\r\n  \r\n  .pagination-controls {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-top: 16px;\r\n    gap: 16px;\r\n  }\r\n  \r\n  .pagination-arrow {\r\n    background-color: #1976d2;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 50%;\r\n    width: 40px;\r\n    height: 40px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    transition: background-color 0.2s ease;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .pagination-arrow i {\r\n    font-size: 20px;\r\n  }\r\n  \r\n  .pagination-arrow:disabled {\r\n    background-color: #ccc;\r\n    cursor: not-allowed;\r\n  }\r\n  \r\n  .pagination-arrow:hover:not(:disabled) {\r\n    background-color: #145a9e;\r\n  }\r\n  \r\n  \r\n  .close-button {\r\n    position: absolute;\r\n    top: 16px;\r\n    right: 16px;\r\n    background: none;\r\n    border: none;\r\n    font-size: 24px;\r\n    cursor: pointer;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
